import { config } from '@fortawesome/fontawesome-svg-core';

import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons/faArrowCircleDown';
import { faBoxes } from '@fortawesome/free-solid-svg-icons/faBoxes';
import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faClipboard } from '@fortawesome/free-solid-svg-icons/faClipboard';
import { faCodeBranch } from '@fortawesome/free-solid-svg-icons/faCodeBranch';
import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faEquals } from '@fortawesome/free-solid-svg-icons/faEquals';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons/faEuroSign';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFileLines } from '@fortawesome/pro-regular-svg-icons/faFileLines';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons/faFileCsv';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faHandPointUp } from '@fortawesome/free-solid-svg-icons/faHandPointUp';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons/faLayerGroup';
import { faLeaf } from '@fortawesome/free-solid-svg-icons/faLeaf';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMedkit } from '@fortawesome/free-solid-svg-icons/faMedkit';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons/faMinusSquare';
import { faPeopleCarry } from '@fortawesome/free-solid-svg-icons/faPeopleCarry';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faRandom } from '@fortawesome/free-solid-svg-icons/faRandom';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons/faShieldAlt';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faTh } from '@fortawesome/free-solid-svg-icons/faTh';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons/faThumbtack';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faTv } from '@fortawesome/free-solid-svg-icons/faTv';
import { faUnlock } from '@fortawesome/free-solid-svg-icons/faUnlock';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserAlt } from '@fortawesome/free-solid-svg-icons/faUserAlt';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faWeight } from '@fortawesome/free-solid-svg-icons/faWeight';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons/faRotateRight';
import { faRotate } from '@fortawesome/free-solid-svg-icons/faRotate';

import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons/faBarcodeRead';
import { faBox } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCircleDashed } from '@fortawesome/pro-regular-svg-icons/faCircleDashed';
import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons/faCirclePlay';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faFileInvoice } from '@fortawesome/pro-regular-svg-icons/faFileInvoice';
import { faFilePlus } from '@fortawesome/pro-regular-svg-icons/faFilePlus';
import { faGift } from '@fortawesome/pro-regular-svg-icons/faGift';
import { faGridDividers } from '@fortawesome/pro-regular-svg-icons/faGridDividers';
import { faLayerGroup as faLayerGroupRegular } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import { faMessagesQuestion } from '@fortawesome/pro-regular-svg-icons/faMessagesQuestion';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons/faLocationDot';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { faPrint as faPrintRegular } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faReceipt } from '@fortawesome/pro-regular-svg-icons/faReceipt';
import { faSplit } from '@fortawesome/pro-regular-svg-icons/faSplit';
import { faSidebarFlip } from '@fortawesome/pro-regular-svg-icons/faSidebarFlip';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faSterlingSign } from '@fortawesome/pro-regular-svg-icons/faSterlingSign';
import { faStore } from '@fortawesome/pro-regular-svg-icons/faStore';
import { faSparkles } from '@fortawesome/pro-regular-svg-icons/faSparkles';
import { faTableColumns } from '@fortawesome/pro-regular-svg-icons/faTableColumns';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faInbox } from '@fortawesome/pro-regular-svg-icons/faInbox';
import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons/faArrowDownToBracket';

import { faBarcodeAlt } from '@fortawesome/pro-light-svg-icons/faBarcodeAlt';
import { faBookOpenCover } from '@fortawesome/pro-light-svg-icons/faBookOpenCover';
import { faBoxUp } from '@fortawesome/pro-light-svg-icons/faBoxUp';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faCopy as faCopyLight } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faLightbulbOn as faLightbulbOnLight } from '@fortawesome/pro-light-svg-icons/faLightbulbOn';
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt';
import { faMemoPad } from '@fortawesome/pro-light-svg-icons/faMemoPad';
import { faShippingFast } from '@fortawesome/pro-light-svg-icons/faShippingFast';
import { faShoppingCart } from '@fortawesome/pro-light-svg-icons/faShoppingCart';
import { faThumbtack as faThumbtackLight } from '@fortawesome/pro-light-svg-icons/faThumbtack';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons/faTrashCan';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { faSquareDashed } from '@fortawesome/pro-light-svg-icons/faSquareDashed';
import { faCheck as faCheckLight } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faArrowUpFromBracket } from '@fortawesome/pro-light-svg-icons/faArrowUpFromBracket';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faFileSpreadsheet } from '@fortawesome/pro-light-svg-icons/faFileSpreadsheet';
import { faFileXmark } from '@fortawesome/pro-light-svg-icons/faFileXmark';

import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faArrowRotateRight } from '@fortawesome/pro-solid-svg-icons/faArrowRotateRight';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons/faBadgeCheck';
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faClipboardListCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardListCheck';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faGrid2Plus } from '@fortawesome/pro-solid-svg-icons/faGrid2Plus';
import { faLightbulbOn } from '@fortawesome/pro-solid-svg-icons/faLightbulbOn';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faPersonCarry } from '@fortawesome/pro-solid-svg-icons/faPersonCarry';
import { faRepeat } from '@fortawesome/pro-solid-svg-icons/faRepeat';
import { faRoute } from '@fortawesome/pro-solid-svg-icons/faRoute';
import { faScanner } from '@fortawesome/pro-solid-svg-icons/faScanner';
import { faSparkles as faSparklesSolid } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faXmarkCircle } from '@fortawesome/pro-solid-svg-icons/faXmarkCircle';

import { faLocationCrosshairs } from '@fortawesome/pro-regular-svg-icons/faLocationCrosshairs';

import { faClipboardCheck } from '@fortawesome/pro-thin-svg-icons/faClipboardCheck';
import { faFileInvoiceDollar } from '@fortawesome/pro-thin-svg-icons/faFileInvoiceDollar';
import { faLayerGroup as faLayerGroupThin } from '@fortawesome/pro-thin-svg-icons/faLayerGroup';
import { faTimelineArrow } from '@fortawesome/pro-thin-svg-icons/faTimelineArrow';
import { faPrint as faPrintThin } from '@fortawesome/pro-thin-svg-icons/faPrint';

import { faChevronCircleLeft } from '@fortawesome/pro-duotone-svg-icons/faChevronCircleLeft';
import { faChevronCircleRight } from '@fortawesome/pro-duotone-svg-icons/faChevronCircleRight';

import { faChevronDown as faChevronDownSharp } from '@fortawesome/sharp-solid-svg-icons/faChevronDown';
import { faChevronRight as faChevronRightSharp } from '@fortawesome/sharp-solid-svg-icons/faChevronRight';
import { faChevronUp as faChevronUpSharp } from '@fortawesome/sharp-solid-svg-icons/faChevronUp';
import { faDiamondExclamation as faDiamondExclamationSharp } from '@fortawesome/sharp-solid-svg-icons/faDiamondExclamation';
import { faGear as faGearSharp } from '@fortawesome/sharp-solid-svg-icons/faGear';
import { faPlus as faPlusSharp } from '@fortawesome/sharp-solid-svg-icons/faPlus';
import { faPrint as faPrintSharp } from '@fortawesome/sharp-solid-svg-icons/faPrint';
import { faUser as faUserSharp } from '@fortawesome/sharp-solid-svg-icons/faUser';
import { faRepeat as faRepeatSharp } from '@fortawesome/sharp-solid-svg-icons/faRepeat';
import { faSliders as faSlidersSharp } from '@fortawesome/sharp-solid-svg-icons/faSliders';

import { faCircleChevronLeft as faCircleChevronLeftSharpLight } from '@fortawesome/sharp-light-svg-icons/faCircleChevronLeft';
import { faEnvelope as faEnvelopeSharpLight } from '@fortawesome/sharp-light-svg-icons/faEnvelope';
import { faPhone as faPhoneSharpLight } from '@fortawesome/sharp-light-svg-icons/faPhone';
import { faTimer as faTimerSharpLight } from '@fortawesome/sharp-light-svg-icons/faTimer';

import { faXmark as faXMarkSharpRegular } from '@fortawesome/sharp-regular-svg-icons/faXmark';
import { faArrowLeft as faArrowLeftSharp } from '@fortawesome/sharp-regular-svg-icons/faArrowLeft';
import { faArrowUpRightFromSquare as faArrowUpRightFromSquareSharpRegular } from '@fortawesome/sharp-regular-svg-icons/faArrowUpRightFromSquare';

import { faDiamondExclamation as faDiamondExclamationSharpDuotone } from '@fortawesome/sharp-duotone-solid-svg-icons/faDiamondExclamation';

config.autoAddCss = false;

export default {
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowCircleDown,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowRotateRight,
  faBolt,
  faBoxes,
  faBriefcase,
  faCalculator,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircleSolid,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboard,
  faCodeBranch,
  faCogs,
  faComment,
  faCreditCard,
  faDesktop,
  faDollarSign,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faEnvelopeSharpLight,
  faEquals,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFlag,
  faFileLines,
  faFileCsv,
  faFilter,
  faHandPointUp,
  faHome,
  faInfoCircle,
  faInbox,
  faLayerGroup,
  faLayerGroupRegular,
  faLeaf,
  faLink,
  faLocationCrosshairs,
  faLock,
  faMedkit,
  faMemoPad,
  faMinus,
  faMinusSquare,
  faPeopleCarry,
  faPhoneAlt,
  faPhoneSharpLight,
  faPlus,
  faPrint,
  faPrintRegular,
  faQuestionCircle,
  faRandom,
  faRedo,
  faShieldAlt,
  faSterlingSign,
  faStore,
  faSync,
  faTags,
  faTh,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimerSharpLight,
  faTrash,
  faTv,
  faUnlock,
  faUser,
  faUserAlt,
  faUsers,
  faWeight,
  faCircleQuestion,
  faRotateRight,
  faRotate,
  // pro icons
  faArrowUpRightFromSquare,
  faBarcodeRead,
  faBox,
  faBadgeCheck,
  faBarcodeAlt,
  faBookOpenCover,
  faBoxUp,
  faBuilding,
  faCalendar,
  faCheckCircle,
  faCircle,
  faCircleDashed,
  faCirclePlay,
  faCircleCheck,
  faClipboardCheck,
  faClipboardListCheck,
  faClock,
  faCopyLight,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePlus,
  faFileSpreadsheet,
  faFileXmark,
  faGift,
  faGridDividers,
  faReceipt,
  faGrid2Plus,
  faLayerGroupThin,
  faLightbulbOn,
  faLightbulbOnLight,
  faLocationDot,
  faMapMarkerAlt,
  faMessagesQuestion,
  faPersonCarry,
  faPlay,
  faPrintThin,
  faRepeat,
  faRoute,
  faScanner,
  faShippingFast,
  faShoppingCart,
  faSidebarFlip,
  faSlidersSharp,
  faSplit,
  faSquare,
  faThumbtackLight,
  faTimelineArrow,
  faTrashCan,
  faPen,
  faSquareDashed,
  faSparkles,
  faTableColumns,
  faCheckLight,
  faArrowUpFromBracket,
  faArrowDownToBracket,
  faXmark,
  faBan,
  faGear,
  faXmarkCircle,
  faPrintSharp,
  faGearSharp,
  faUserSharp,
  faDiamondExclamationSharp,
  faSparklesSolid,
  faChevronDownSharp,
  faChevronRightSharp,
  faChevronUpSharp,
  faCircleChevronLeftSharpLight,
  faMagnifyingGlass,
  faXMarkSharpRegular,
  faArrowLeftSharp,
  faPlusSharp,
  faDiamondExclamationSharpDuotone,
  faRepeatSharp,
  faArrowUpRightFromSquareSharpRegular,
};
